export const APP_URI = "/";